import { render, staticRenderFns } from "./AdminSections.vue?vue&type=template&id=1dc5282d"
import script from "./AdminSections.vue?vue&type=script&lang=js"
export * from "./AdminSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports